let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("5cjYh")]).then(() => parcelRequire('biKU8'));